var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 1V2.25H10.25V1H11.75V2.25H14C14.9665 2.25 15.75 3.0335 15.75 4V14C15.75 14.9665 14.9665 15.75 14 15.75H2C1.0335 15.75 0.25 14.9665 0.25 14V4C0.25 3.0335 1.0335 2.25 2 2.25H4.25V1H5.75ZM10.25 3.75H5.75L5.75 6.25H10.25L10.25 3.75ZM11.75 6.25L11.75 3.75H14C14.1381 3.75 14.25 3.86193 14.25 4V6.25H11.75ZM2 3.75H4.25L4.25 6.25H1.75V4C1.75 3.86193 1.86193 3.75 2 3.75ZM1.75 7.75V14C1.75 14.1381 1.86193 14.25 2 14.25H14C14.1381 14.25 14.25 14.1381 14.25 14V7.75H1.75Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.f9b42ccf0e4a95861c7cd5160ee2cb0a.svg";
export { ForwardRef as ReactComponent };